module.exports = __webpack_public_path__ + "img/frame (55).3ea0f551.jpg";